module.exports = __webpack_public_path__ + "static/img/dual-ball.062100ff.svg";